import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setErrorMsg,
  setIsDeleteConfirmShown,
  setIsEditMode,
  setIsErrorMsg,
  setIsModalsBgShown,
  setSelectedDataForEdit,
  setSuccessMsg,
} from "../../redux/globalFunctions/globalFnSlice";

// Custom Hook to handle status effects.
export function useStatusEffect({
  status,
  successMessage,
  errorMessage,
  onSuccess = null,
  onError = null,
  resetStatus,
  reFetch = null,
  navigateLocation = null,
  onPage,
  resetForm = null,
  resetSelectedDataForEdit = null,
  resetEditMode = null,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "success") {
      /* if (onSuccess === null) return; */
      if (resetForm !== null) {
        setTimeout(() => {
          dispatch(resetForm());
        }, 2000);
      }

      if (resetEditMode !== null) {
        setTimeout(() => {
          dispatch(setIsEditMode(false));
        }, 2000);
      }

      if (resetSelectedDataForEdit !== null) {
        setTimeout(() => {
          dispatch(setSelectedDataForEdit(null));
        }, 2000);
      }

      if (reFetch !== null) {
        if (onPage) {
          dispatch(reFetch({ page: onPage }));
        } else {
          dispatch(reFetch());
        }
      }

      if (onSuccess !== null) {
        dispatch(onSuccess(false));
      }

      if (successMessage !== null) {
        dispatch(setSuccessMsg(successMessage));
        dispatch(setIsModalsBgShown(true));
        dispatch(setIsDeleteConfirmShown(true));
      }

      setTimeout(() => {
        dispatch(setIsModalsBgShown(false));

        if (resetStatus !== null) {
          dispatch(resetStatus());
        }
        dispatch(setIsDeleteConfirmShown(false));

        if (navigateLocation !== null) {
          navigate(`${navigateLocation}`);
        }
      }, 2000);
    } else if (status === "error") {
      dispatch(setIsModalsBgShown(true));
      if (onError !== null) {
        dispatch(onError());
        dispatch(setIsModalsBgShown(true));
      }

      dispatch(setErrorMsg(errorMessage));
      dispatch(setIsErrorMsg(true));

      setTimeout(() => {
        dispatch(setIsModalsBgShown(false));
        if (resetStatus !== null) {
          dispatch(resetStatus());
        }
        dispatch(setIsErrorMsg(false));
        if (onError !== null) {
          dispatch(onError(true));
        }
      }, 2000);
    }
  }, [status]);
}
